
// import React, { useEffect, useState } from 'react';
// import {
//   Form,
//   Input,
//   InputNumber,
//   Button,
//   DatePicker,
//   Typography,
//   Select,
//   Row,
//   Col,
//   Card,
//   Table,
//   message,
// } from 'antd';
// import { useNavigate } from 'react-router-dom';
// import { DeleteOutlined } from '@ant-design/icons';

// const { Title } = Typography;
// const { TextArea } = Input;

// const sectionStyle = {
//   marginBottom: 24,
//   padding: 24,
//   borderRadius: 12,
//   background: '#fff',
//   border: '1px solid #f0f0f0',
//   boxShadow: '0 1px 3px rgba(0, 0, 0, 0.06)',
// };

// const medicineOptions = [
//   { label: 'Paracetamol 500mg', value: 'Paracetamol 500mg' },
//   { label: 'Ibuprofen 400mg', value: 'Ibuprofen 400mg' },
//   { label: 'Amoxicillin 250mg', value: 'Amoxicillin 250mg' },
//   { label: 'Ciprofloxacin 500mg', value: 'Ciprofloxacin 500mg' },
//   { label: 'Azithromycin 250mg', value: 'Azithromycin 250mg' },
//   { label: 'Metformin 500mg', value: 'Metformin 500mg' },
//   { label: 'Atorvastatin 10mg', value: 'Atorvastatin 10mg' },
//   { label: 'Pantoprazole 40mg', value: 'Pantoprazole 40mg' },
//   { label: 'Losartan 50mg', value: 'Losartan 50mg' },
//   { label: 'Cetirizine 10mg', value: 'Cetirizine 10mg' },
// ];

// const NewPrescriptionForm = () => {
//   const [form] = Form.useForm();
//   const navigate = useNavigate();
//   const [medications, setMedications] = useState([]);

//   const onFinish = (values) => {
//     const finalData = { ...values, medication: medications };
//     console.log('Prescription Submitted:', finalData);
//     message.success('Form submitted!');
//     setTimeout(() => navigate('/'), 1000); // redirect after success
//   };

//   const onReset = () => {
//     form.resetFields();
//     setMedications([]);
//     message.info('Form cleared');
//   };

//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       const isMac = navigator.platform.toUpperCase().includes('MAC');
//       const isSave = (isMac && e.metaKey && e.key === 's') || (!isMac && e.ctrlKey && e.key === 's');
//       const isCancel = e.key === 'Escape';

//       if (isSave) {
//         e.preventDefault();
//         form.submit();
//       }

//       if (isCancel) {
//         e.preventDefault();
//         navigate('/');
//       }
//     };

//     window.addEventListener('keydown', handleKeyDown);
//     return () => window.removeEventListener('keydown', handleKeyDown);
//   }, [form, navigate]);

//   const handleMedicineSelect = (value) => {
//     const alreadyAdded = medications.some((med) => med.name === value);
//     if (!alreadyAdded) {
//       setMedications([...medications, { name: value, quantity: 1 }]);
//     }
//   };

//   const handleQuantityChange = (value, index) => {
//     const updated = [...medications];
//     updated[index].quantity = value;
//     setMedications(updated);
//   };

//   const handleRemove = (index) => {
//     const updated = [...medications];
//     updated.splice(index, 1);
//     setMedications(updated);
//   };

//   const medicineColumns = [
//     {
//       title: 'Medicine',
//       dataIndex: 'name',
//       key: 'name',
//       width: '60%',
//       render: (text) => (
//         <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={text}>
//           {text}
//         </div>
//       ),
//     },
//     {
//       title: 'Qty',
//       key: 'quantity',
//       width: '20%',
//       render: (_, record, index) => (
//         <InputNumber
//           min={1}
//           value={record.quantity}
//           onChange={(value) => handleQuantityChange(value, index)}
//           size="small"
//           style={{ width: '100%' }}
//         />
//       ),
//     },
//     {
//       title: 'Action',
//       key: 'action',
//       width: '20%',
//       render: (_, __, index) => (
//         <Button
//           type="text"
//           icon={<DeleteOutlined />}
//           danger
//           onClick={() => handleRemove(index)}
//         />
//       ),
//     },
//   ];


//   return (
//     <div style={{ background: '#f9fafb', padding: 32 }}>
//       <Title level={4} style={{ marginBottom: 32 }}>
//         Add Patient (Ctrl/⌘ + S to save, Esc to cancel)
//       </Title>

//       <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
//         <Card style={sectionStyle} title="Patient Information" bordered={false}>
//           <Row gutter={16}>
//             <Col xs={24} md={12}>
//               <Form.Item
//                 label="Patient Name"
//                 name="patient"
//                 rules={[{ required: true, message: 'Please enter patient name' }]}
//               >
//                 <Input autoFocus placeholder="Enter full name" />
//               </Form.Item>
//             </Col>
//             <Col xs={24} md={12}>
//               <Form.Item label="Address" name="address">
//                 <Input placeholder="Enter address" />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={16}>
//             <Col xs={24} sm={12} md={6}>
//               <Form.Item label="Age" name="age">
//                 <InputNumber min={0} style={{ width: '100%' }} placeholder="Age" />
//               </Form.Item>
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <Form.Item label="Gender" name="gender">
//                 <Select
//                   placeholder="Select gender"
//                   options={[
//                     { value: 'male', label: 'Male' },
//                     { value: 'female', label: 'Female' },
//                     { value: 'other', label: 'Other' },
//                   ]}
//                 />
//               </Form.Item>
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <Form.Item label="Height (cm)" name="height">
//                 <InputNumber min={0} style={{ width: '100%' }} placeholder="Height" />
//               </Form.Item>
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <Form.Item label="Weight (kg)" name="weight">
//                 <InputNumber min={0} style={{ width: '100%' }} placeholder="Weight" />
//               </Form.Item>
//             </Col>
//           </Row>

//           <Row gutter={16}>
//             <Col xs={24} sm={12} md={6}>
//               <Form.Item label="Pulse" name="pulse">
//                 <InputNumber min={0} style={{ width: '100%' }} placeholder="Pulse" />
//               </Form.Item>
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <Form.Item label="BP" name="bp">
//                 <Input placeholder="e.g. 120/80" />
//               </Form.Item>
//             </Col>
//             <Col xs={24} sm={12} md={6}>
//               <Form.Item label="Temperature (°C)" name="temperature">
//                 <InputNumber step={0.1} style={{ width: '100%' }} placeholder="Temp °C" />
//               </Form.Item>
//             </Col>
//           </Row>
//         </Card>

// <Card style={sectionStyle} title="Medical History" bordered={false}>
//   <Row gutter={16}>
//     <Col span={12}>
//       <Form.Item label="Chief Complaints" name="complaints">
//         <TextArea rows={6} placeholder="Describe complaints..." style={{ height: '190px' }} />
//       </Form.Item>
//     </Col>
//     <Col span={12}>
//       <Form.Item label="Past History" name="history">
//         <TextArea rows={6} placeholder="Any relevant past history..." style={{ height: '190px' }} />
//       </Form.Item>
//     </Col>
//   </Row>
// </Card>



//         <Card style={sectionStyle} title="Diagnosis & Medication" bordered={false}>
//           <Row gutter={16}>
//             <Col xs={24} md={12}>
//               <Form.Item label="Investigations" name="investigation">
//                 <TextArea rows={2} placeholder="Test results or planned investigations..." style={{height:'350px'}} />
//               </Form.Item>
//             </Col>
//             <Col xs={24} md={12}>
//               <Form.Item label="Prescribed Medication">
//                 <Select
//                   showSearch
//                   placeholder="Search & select medicine"
//                   onSelect={handleMedicineSelect}
//                   dropdownStyle={{ maxHeight: 250, overflow: 'auto' }}
//                   optionFilterProp="label"
//                   filterOption={(input, option) =>
//                     (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
//                   }
//                   options={medicineOptions}
//                 />
//               </Form.Item>
//               <div style={{ maxWidth: '100%', overflowX: 'auto' }}>
//                 <Table
//                   size="small"
//                   columns={medicineColumns}
//                   dataSource={medications.map((med, idx) => ({ ...med, key: idx }))}
//                   pagination={false}
//                   bordered
//                   style={{ marginTop: 8 }}
//                 />
//               </div>

//             </Col>
//           </Row>
//         </Card>

//         <Card style={sectionStyle} title="Doctor Notes" bordered={false}>
//           <Row gutter={16}>
//             <Col xs={24} md={12}>
//               <Form.Item label="Summary/Doctor Notes" name="summary">
//                 <TextArea rows={3} placeholder="Additional notes or summary..." />
//               </Form.Item>
//             </Col>
//             <Col xs={24} md={6}>
//               <Form.Item label="Prescribed By" name="doctor">
//                 <Input placeholder="Doctor's name" />
//               </Form.Item>
//             </Col>
//             <Col xs={24} md={6}>
//               <Form.Item label="Date" name="date">
//                 <DatePicker style={{ width: '100%' }} placeholder="Select date" />
//               </Form.Item>
//             </Col>
//           </Row>
//         </Card>

//         <Form.Item style={{ textAlign: 'right' }}>
//           <Button type="primary" htmlType="submit" style={{ marginTop: 16 }}>
//             Submit Prescription
//           </Button>
//         </Form.Item>
//       </Form>
//     </div>
//   );
// };

// export default NewPrescriptionForm;

// """"""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""""

import { pastHistory } from '../data/sampleData';
import { medicineOptions } from '../data/sampleData';
import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  InputNumber,
  Button,
  DatePicker,
  Typography,
  Select,
  Row,
  Col,
  Card,
  Table,
  message,
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { DeleteOutlined, UserOutlined } from '@ant-design/icons';

const { Title } = Typography;
const { TextArea } = Input;

const sectionStyle = {
  marginBottom: 32,
  padding: 24,
  borderRadius: 16,
  background: '#ffffff',
  border: '1px solid #e0e0e0',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)',
};

const inputBgStyle = {
  backgroundColor: '#f9f9f9',
  borderRadius: 6,
};

const NewPrescriptionForm = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [medications, setMedications] = useState([]);
  const [showHistory, setShowHistory] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [setPatientId] = useState('');

  const onFinish = (values) => {
    const finalData = { ...values, medication: medications };
    console.log('Prescription Submitted:', finalData);
    message.success('Form submitted!');
    setTimeout(() => navigate('/prescriptions'), 1000);
  };


  useEffect(() => {
    const handleKeyDown = (e) => {
      const isMac = navigator.platform.toUpperCase().includes('MAC');
      const isSave = (isMac && e.metaKey && e.key === 's') || (!isMac && e.ctrlKey && e.key === 's');
      const isCancel = e.key === 'Escape';

      if (isSave) {
        e.preventDefault();
        form.submit();
      }

      if (isCancel) {
        e.preventDefault();
        navigate('/prescriptions');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [form, navigate]);

  const handleMedicineSelect = (value) => {
    const alreadyAdded = medications.some((med) => med.name === value);
    if (!alreadyAdded) {
      setMedications([...medications, { name: value, quantity: 1 }]);
    }
  };

  const handleQuantityChange = (value, index) => {
    const updated = [...medications];
    updated[index].quantity = value;
    setMedications(updated);
  };

  const handleRemove = (index) => {
    const updated = [...medications];
    updated.splice(index, 1);
    setMedications(updated);
  };

  const medicineColumns = [
    {
      title: 'Medicine',
      dataIndex: 'name',
      key: 'name',
      width: '60%',
      render: (text) => (
        <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={text}>
          {text}
        </div>
      ),
    },
    {
      title: 'Qty',
      key: 'quantity',
      width: '20%',
      render: (_, record, index) => (
        <InputNumber
          min={1}
          value={record.quantity}
          onChange={(value) => handleQuantityChange(value, index)}
          size="small"
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'Action',
      key: 'action',
      width: '20%',
      render: (_, __, index) => (
        <Button
          type="text"
          icon={<DeleteOutlined />}
          danger
          onClick={() => handleRemove(index)}
        />
      ),
    },
  ];

  return (
    <div style={{ background: '#f9fafb', padding: 32 }}>
      <Title level={4} style={{ marginBottom: 32 }}>
        Add Patient (Ctrl/⌘ + S to save, Esc to cancel)
      </Title>

      <Form form={form} layout="vertical" onFinish={onFinish} autoComplete="off">
        <Card style={sectionStyle} title={<Title level={5}><UserOutlined /> Patient Information</Title>} bordered={false}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item
                label="Patient Name"
                name="patient"
                rules={[{ required: true, message: 'Please enter patient name' }]}
              >
                <Input autoFocus placeholder="Enter full name" />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <Form.Item label="Address" name="address">
                <Input placeholder="Enter address" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Age" name="age">
                <InputNumber min={0} style={{ width: '100%' }} placeholder="Age" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Gender" name="gender">
                <Select
                  placeholder="Select gender"
                  options={[
                    { value: 'male', label: 'Male' },
                    { value: 'female', label: 'Female' },
                    { value: 'other', label: 'Other' },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Height (cm)" name="height">
                <InputNumber min={0} style={{ width: '100%' }} placeholder="Height" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Weight (kg)" name="weight">
                <InputNumber min={0} style={{ width: '100%' }} placeholder="Weight" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Pulse" name="pulse">
                <InputNumber min={0} style={{ width: '100%' }} placeholder="Pulse" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="BP" name="bp">
                <Input placeholder="e.g. 120/80" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Temperature (°C)" name="temperature">
                <InputNumber step={0.1} style={{ width: '100%' }} placeholder="Temp °C" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Patient ID" name="patientId" rules={[{ required: true, message: 'Please enter Patient ID' }]}>
                <Input onChange={(e) => setPatientId(e.target.value)} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={6}>
              <Form.Item label="Date" name="date">
                <DatePicker style={{ width: '100%', ...inputBgStyle }} placeholder="Select date" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <Card style={sectionStyle} title={<Title level={5}>Medical History</Title>} bordered={false}>
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item label={<strong>Chief Complaints</strong>} name="complaints">
                <TextArea placeholder="Describe complaints..." autoSize={{ minRows: 10 }} style={inputBgStyle} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label={<strong>Past History</strong>}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                  <Button type="primary" onClick={() => setShowHistory(!showHistory)}>
                    {showHistory ? 'Hide Past History' : 'Show Past History'}
                  </Button>
                  {showHistory && (
                    <Input
                      placeholder="Search by reason (e.g. fever, cough)"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      style={{ maxWidth: 300, ...inputBgStyle }}
                    />
                  )}
                </div>

                {showHistory && (
                  <div
                    style={{
                      maxHeight: 200,
                      overflowY: 'auto',
                      background: '#f9f9f9',
                      padding: 12,
                      borderRadius: 8,
                      border: '1px solid #eaeaea',
                    }}
                  >
                    {pastHistory
                      .filter((entry) =>
                        entry.reason.toLowerCase().includes(searchText.toLowerCase())
                      )
                      .map((entry) => (
                        <div
                          key={entry.id}
                          style={{
                            marginBottom: 8,
                            padding: 8,
                            background: '#fff',
                            borderRadius: 4,
                          }}
                        >
                          <strong>{entry.date}</strong> at <strong>{entry.time}</strong>: {entry.reason}
                        </div>
                      ))}
                  </div>
                )}
              </Form.Item>
            </Col>

          </Row>
        </Card>

        <Card style={sectionStyle} title={<Title level={5}>Diagnosis & Medication</Title>} bordered={false}>
          <Row gutter={24}>
            <Col xs={24} md={12}>
              <Form.Item label="Investigations" name="investigation">
                <TextArea placeholder="Test results or planned investigations..." autoSize={{ minRows: 16 }} style={inputBgStyle} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item label="Prescribed Medication">
                <Select
                  showSearch
                  placeholder="Search & select medicine"
                  onSelect={handleMedicineSelect}
                  dropdownStyle={{ maxHeight: 250, overflow: 'auto' }}
                  optionFilterProp="label"
                  filterOption={(input, option) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
                  options={medicineOptions}
                  style={{ width: '100%', ...inputBgStyle }}
                />
              </Form.Item>
              <div style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #f0f0f0', borderRadius: 8 }}>
                <Table
                  size="small"
                  columns={medicineColumns}
                  dataSource={medications.map((med, idx) => ({ ...med, key: idx }))}
                  pagination={false}
                  bordered
                  style={{ marginTop: 8 }}
                />
              </div>
            </Col>
          </Row>
        </Card>

        <Card style={sectionStyle} title={<Title level={5}>Doctor Notes</Title>} bordered={false}>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Form.Item label="Summary/Doctor Notes" name="summary">
                <TextArea rows={3} placeholder="Additional notes or summary..." />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item label="Prescribed By" name="doctor">
                <Input placeholder="Doctor's name" />
              </Form.Item>
            </Col>
          </Row>
        </Card>

        <div style={{
          position: 'sticky',
          bottom: 0,
          background: '#fff',
          padding: 16,
          borderTop: '1px solid #eee',
          textAlign: 'right',
          zIndex: 10
        }}>
          <Button type="primary" htmlType="submit">
            Submit Prescription
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default NewPrescriptionForm;